export default __webpack_public_path__ + "static/media/how-priya-works.ab34ea5d.png";